import styled, { css } from 'styled-components';

export const StatusIconContainer = styled.div`
  width: 100vw;
  height: 89vh;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  overflow: auto;
`;

export const IconContainer = styled.div`
  ${(props) =>
    props.count <= 8 &&
    css`
      width: 375px;
      font-size: 3rem;
      margin: 0.5em 0.2em;
    `}
  ${(props) =>
    props.count <= 24 &&
    props.count > 8 &&
    css`
      width: 215px;
      font-size: 1.7rem;
      margin: 0.5em 0.2em;
    `}
  ${(props) =>
    props.count > 24 &&
    css`
      width: 175px;
      font-size: 1.35rem;
      margin: 1.5em 0.2em;
    `}
  
  .statusImage {
    display: flex;
    position: relative;
    ${(props) =>
      props.count <= 8 &&
      css`
        width: 375px;
      `}
    ${(props) =>
      props.count <= 24 &&
      props.count > 8 &&
      css`
        width: 215px;
      `}
    ${(props) =>
      props.count > 24 &&
      css`
        width: 175px;
      `}

    div {
      position: absolute;
      top: 3.5em;
      font-size: 0.7vw;
      text-align: center;

      p {
        margin: 0px;
      }
    }

    div.titleInitial {
      left: 0.7em;
      top: 0.5em;
      font-size: 1.3em;
      font-weight: 500;
      line-height: 1.2;

      ${(props) =>
        props.statusFlag === 'danger'
          ? css`
              color: #ff0018;
            `
          : props.statusFlag === 'warning'
          ? css`
              color: #e8b23a;
            `
          : props.statusFlag === 'none'
          ? css`
              color: #e0e0e0;
            `
          : css`
              color: #50bb5b;
            `}
    }

    div.blue {
      color: #50bb5b;
      font-size: 1em;
      width: 100%;
    }
    div.warning {
      color: #e8b23a;
      font-size: 1em;
      width: 100%;
    }
    div.danger {
      color: #ff0018;
      font-size: 1em;
      width: 100%;
    }
    div.none {
      color: #e0e0e0;
      font-size: 1em;
      width: 100%;
    }

    img {
      width: 100%;

      ${(props) =>
        props.statusFlag === 'danger'
          ? css`
              content: ${(props) => props.theme.mainInfoIconDanger};
            `
          : props.statusFlag === 'warning'
          ? css`
              content: ${(props) => props.theme.mainInfoIconWarning};
            `
          : props.statusFlag === 'none'
          ? css`
              content: ${(props) => props.theme.mainInfoIconNone};
            `
          : css`
              content: ${(props) => props.theme.mainInfoIconBlue};
            `}
    }

    svg {
      position: absolute;
      left: 3.5em;
      top: 6em;
      transform: scale(1);
    }
  }

  .blank {
    flex: 1;
  }

  .statusDetailBox {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    flex: 8;
    width: 360px;
    max-height: 450px;
    padding: 20px 30px;
    margin: 20px;
    display: flex;

    .statusModuleList {
      width: 100%;
      min-height: 410px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      flex-wrap: wrap;
    }
  }
`;
